/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-07-10 09:45:11
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-08-10 14:35:22
 * @FilePath: \合联\oms\src\api\bag\list.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "@/libs/api.request";

export const getBag = data => {
  return axios.request({
    url: "/warehouse/bag",
    method: "POST",
    data
  });
};

export const getDetails = params => {
  return axios.request({
    url: "/warehouse/shipments/package",
    method: "get",
    params
  });
};

// 板货称重
export const postStatist = data => {
  return axios.request({
    url: `/warehouse/shipments/statistics`,
    method: "POST",
    data
  });
};

// 移入移出
export const postMoveCnb = data => {
  return axios.request({
    url: `/warehouse/bag/handleOrder`,
    method: "POST",
    data
  });
};


export const exportPackage = data => {
  return axios.request({
    url: `/warehouse/packing/exportPackage`,
    method: "POST",
    data
  });
};

export const boardBag = data => {
  return axios.request({
    url: `/warehouse/bag/boardBag`,
    method: "POST",
    data
  });
};


export const packagePrint = data => {
  return axios.request({
    url: `/warehouse/warehouse/packagePrint`,
    method: "POST",
    data
  });
};


export const getChannel = params => {
  return axios.request({
    url: "/common/getChannel",
    method: "GET",
    params
  });
};

export const getSite = params => {
  return axios.request({
    url: "/common/getSite",
    method: "GET",
    params
  });
};

export const packageCheck = data => {
  return axios.request({
    url: `/warehouse/warehouse/packageCheck`,
    method: "POST",
    data
  });
};


export const getClientType = params => {
  return axios.request({
    url: "/common/getClientType",
    method: "GET",
    params
  });
};